/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     费用中心-总览 API 接口
  | @Version:   2019-02-26  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getExpenseOverviewApi() {
  return request({
    url: '?c=expense&a=overview&do=stats',
    method: 'get'
  })
}

export function getExpenseMonthTrendApi() {
  return request({
    url: '?c=expense&a=overview&do=trend',
    method: 'get'
  })
}
